import { getElements, ifSelectorExist } from './utils';

export const openAllAccordions = () => {
  const accordions = getElements('.accordion-faq-item');
  if (accordions.length != 0) {
    accordions.forEach(accordion => {
      const content = accordion.querySelector('.accordion-faq-item-content');
      accordion.classList.add('active');
      content.style.maxHeight = content.scrollHeight + 'px';
    });
  }
};

export const openFirstAccordion = () => {
  const faqBlocks = document.querySelectorAll('.faq-accordion-block');

  faqBlocks.forEach(faqBlock => {
    const accordions = faqBlock.querySelectorAll('.accordion-faq-item');
    if (accordions.length !== 0) {
      const faqArchiveWrapper = faqBlock.closest('.faq-calljazz-block');
      if (!ifSelectorExist(faqArchiveWrapper)) {
        const content = accordions[0].querySelector(
          '.accordion-faq-item-content'
        );
        accordions[0].classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    }
  });
};
